export default (state = true, action: any) => {
  switch (action.type) {
    default:
      return state;
  }
};
